export const HOME_ROUTE = '/';
export const LOGIN_ROUTE = '/login';
export const STYLE_GUIDE = '/style-guide';
export const PAGE_NOT_FOUND = '/page-not-found';
export const PROJECT_LISTING = '/projects';
export const PROJECT_BOOKINGS = '/projects/:projectId/bookings';
export const PROJECT_BOOKINGS_CALENDAR = '/projects/:projectId/bookings/calendar';
export const PROJECT_BOOKINGS_LIST = '/projects/:projectId/bookings/list';
export const PROJECT_ROLES_INTERNAL = '/projects/:projectId/roles/internal';
export const PROJECT_ROLES_EXTERNAL = '/projects/:projectId/roles/external';
export const PROJECT_DOCUMENTS = '/projects/:projectId/documents';
export const PROJECT_SETTINGS = '/projects/:projectId/settings';
export const INTERNAL_USERS = '/internal-users';
export const INTERNAL_USER_PROJECTS = '/internal-users/:userId/projects';
export const EXTERNAL_USERS = '/external-users';
export const EXTERNAL_USER_CONTACTS = '/external-users/:userId/contacts';
export const EXTERNAL_USER_PROJECTS = '/external-users/:userId/projects';
export const PROJECT_MANAGEMENT = '/project-management';
export const FORBIDDEN = '/forbidden';
export const NOTIFICATIONS = '/notifications';
export const PROFILE = '/profile';
export const COMPANY_CONTACTS = '/company-contacts';
export const BARRIER_MANAGEMENT = '/barrier-management';
export const NOTIFICATIONS_EMAIL = '/notification-email';
export const BARRIER_LOGS = '/barrier/:barrierId/logs';
